module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"acknowledgeError":"Acknowledge Error"},"de":{"acknowledgeError":"Fehler quittieren"},"fr":{"acknowledgeError":"Reconnaître l\u0027erreur"},"it":{"acknowledgeError":"Riconosci l\u0027errore"}}')
  delete Component.options._Ctor
}
